<template>
  <div class="item">
    <div class="checkbox">
      <i class="fas fa-check-square" v-if="item.bought" @click="unsetBought(item.id)"></i>
      <i class="far fa-square" v-else @click="setBought(item.id)"></i>
    </div>

    <div class="content">
      <div>
        <a :href="item.link" target="_blank" class="link">{{ item.name }}</a>

        {{ item.manufacturer }}
      </div>

      <div class="count">
        {{ item.count }} шт/уп, {{ item.packages }} уп.
      </div>
    </div>

    <div class="details-button" @click="showDetails">
      <i class="fas fa-angle-down"></i>
    </div>

    <div class="details" v-show="details">
      <div class="course">
        <strong>Курс</strong>

        <div>{{ item.duration }} {{item.interval}}</div>

        <div>{{ item.quantity }} {{item.times}} р. в день</div>
      </div>

      <div class="stores">
        <strong>Где купить</strong>

        <div
          v-for="stock in prescription.drug.stocks"
          :key="stock.id">
          <a
            :href="stock.link"
            target="blank">{{ stock.store.name }}</a>
        </div>
      </div>

      <div class="analogs">
        <strong>Аналоги (в случае отсутствия основного препарата)</strong>

        <div v-if="item.analogs.length > 0">
          <div v-for="(analog, analogKey) in item.analogs" :key="analogKey">
            <a :href="analog.link" target="_blank" class="link">{{analog.name}}</a>

            {{analog.manufacturer}}
          </div>
        </div>

        <div v-else>У этого препарата нет аналогов</div>
      </div>

      <div class="warning" v-if="prescription.drug.analogs.length > 0">
        <i class="fas fa-exclamation-triangle"></i>

        <div>
          В случае покупки аналога, внимательно смотрите дозировку и количество.
          Сообщите ассистенту в случае, если вы купили аналог
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import formatDate from '../../utils/formatDate';
  import calculateDaysCount from '../../utils/calculateDaysCount';
  import declensionNumbers from '../../utils/declensionNumbers';
  import {MS_IN_DAY, FORMAT_NAMES} from '../../constants';

  export default {
    name: 'ShopListItem',

    props: ['prescription'],

    data() {
      return {
        details: false,
      };
    },

    computed: {
      item() {
        const { id, bought, drug, startDate, finishDate, quantity, times } = this.prescription;
        const analogs = drug.analogs.map(analog => {
          let link = '';

          for (const stock of analog.stocks) {
            if(stock.link) {
              link = stock.link;

              break;
            }
          }

          return {
            id: analog.id,
            name: `${analog.name} ${analog.measure || ''} ${analog.measureUnit || ''}`,
            manufacturer: analog.manufacturer ? analog.manufacturer.name : '',
            link,
          };
        });

        let link = '';

        for (const stock of drug.stocks) {
          if(stock.link) {
            link = stock.link;

            break;
          }
        }

        return {
          id,
          name: `${drug.name} ${drug.measure || ''} ${drug.measureUnit || ''}`,
          manufacturer: drug.manufacturer ? drug.manufacturer.name : '',
          bought,
          count: this.countPerPackage,
          packages: this.packagesCount,
          duration: this.duration,
          interval: `${this.formatDate(startDate)} - ${this.formatDate(finishDate)}`,
          quantity: `${quantity} ${this.declensionNumbers(quantity, drug.format.name)}`,
          times: times.length,
          analogs,
          link,
        };
      },

      totalCount() {
        const {startDate, finishDate, times, quantity} = this.prescription;
        const days = calculateDaysCount(startDate, finishDate);

        return days * times.length * quantity;
      },

      countPerPackage() {
        const packages = this.prescription.drug.packages.map(item => item.count);

        packages.sort((a, b) => a - b);

        for (const pack of packages) {
          if (pack >= this.totalCount) {
            return pack;
          }
        }

        return packages[packages.length - 1];
      },

      packagesCount() {
        return Math.ceil(this.totalCount / this.countPerPackage);
      },

      duration() {
        const startDate = new Date(this.prescription.startDate);
        const finishDate = new Date(this.prescription.finishDate);
        const compareDate = new Date(finishDate.getTime() + MS_IN_DAY);

        if (startDate.getDate() === compareDate.getDate()) {
          const yearsDiff = (compareDate.getFullYear() - startDate.getFullYear());

          return compareDate.getMonth() + (yearsDiff * 12) - startDate.getMonth() + ' мес.';
        }

        const durationInMs = compareDate.getTime() - startDate.getTime();
        const durationInDays = parseInt(durationInMs / MS_IN_DAY);

        if (durationInDays % 7 === 0 && durationInDays !== 0) {
          return durationInDays / 7 + 'нед.';
        }

        return durationInDays + 'дн.';
      },
    },

    methods: {
      showDetails() {
        this.details = !this.details;
      },

      formatDate(date) {
        return formatDate(new Date(date), 'd.m.y');
      },

      declensionNumbers(count, name) {
        const formatName = FORMAT_NAMES.find(item => item[0] === name);
        const [, few, one, two] = formatName || [name, name, name, name];

        return declensionNumbers(count, few, one, two);
      },

      async setBought(id) {
        try {
          await this.$store.dispatch('SET_BOUGHT_PRESCRIPTION', id);
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },

      async unsetBought(id) {
        try {
          await this.$store.dispatch('UNSET_BOUGHT_PRESCRIPTION', id);
        } catch (e) {
          await this.$store.dispatch('ERROR', e);
        }
      },
    }
  }
</script>
<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .item {
    position: relative;
    border-top: 1px solid $light-gray;

    .checkbox {
      position: absolute;
      left: 15px;
      top: 20px;
      height: 10px;
      font-size: 18px;
      color: $primary;
    }

    .content {
      padding: 15px 40px 15px 50px;
      font-size: 12px;

      a {
        margin-right: 10px;
        font-weight: bold;
        text-decoration: underline;
        color: $primary;
      }

      .count {
        font-size: 12px;
      }
    }

    .details-button {
      position: absolute;
      right: 15px;
      top: 22px;
      height: 10px;
      font-size: 18px;
      color: $primary;
    }

    .details {
      padding: 10px 20px 20px;
      font-size: 12px;
      border-top: 1px solid $light-gray;

      strong {
        display: block;
        padding: 10px 0 5px;
      }

      .course {

      }

      .stores {
        margin: 0 0 10px;

        a {
          margin-right: 10px;
          color: $primary;
          text-decoration: underline;
        }
      }

      .analogs {
        margin: 0 0 10px;

        a {
          margin-right: 10px;
          color: $primary;
          text-decoration: underline;
        }
      }

      .warning {
        position: relative;
        padding: 5px 5px 5px 30px;
        border: 1px solid $yellow;
        background-color: $yellow-light;

        i {
          position: absolute;
          top: 10px;
          left: 5px;
          color: $yellow;
        }
      }
    }
  }
</style>
